import gql from 'graphql-tag';

import { executeGqlMutation } from 'src/graphql/client';
import { getSingleProp } from 'src/lib/graphql';

const MUTATION = gql`
  mutation DeleteCustomToneOfVoice($id: ID!) {
    deleteCustomToneOfVoice(id: $id) {
      id
    }
  }
`;

export const deleteCustomToneOfVoice = (id) => {
  const variables = {
    id,
  };

  return executeGqlMutation({
    mutation: MUTATION,
    variables,
  }).then(({ data }) => getSingleProp(data));
};
